export const ActionTypes = {
    loaderOpenClose: "LOADER_OPEN_CLOSE"
}